import React from 'react'

const TextField = ( { iconComponent, label, name, value, type = "text" } ) => {
    return (
      <div className={"flex flex-col items-start my-2 px-3"}>
          <label className="text-sm py-1">{label}</label>
          <div className={"inline-flex w-full rounded-sm border border-blue-300" }>
            <div className="w-1/6 flex items-center justify-center bg-gray-50">
              <span>{iconComponent}</span>
            </div>
            <input 
              name={name}
              disabled={true}
              id={name}
              type={type} 
              placeholder={label}
              value={value}
              autoComplete="off"
              className={ "w-full px-3 py-1 focus:outline-none focus:text-gray-600 placeholder-blue-300 text-sm"  } 
            />
        </div>
      </div>
    )
}

export default TextField
